var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRedo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1683",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "redo - Outline",
    d: "M14.5-13.05a.551.551 0 0 1 .55.55v4a.551.551 0 0 1-.55.55h-4a.551.551 0 0 1-.55-.55.551.551 0 0 1 .55-.55h2.6a5.988 5.988 0 0 0-2.124-2.1A5.921 5.921 0 0 0 8-11.95 5.957 5.957 0 0 0 2.05-6 5.957 5.957 0 0 0 8-.05a5.908 5.908 0 0 0 4.689-2.288.546.546 0 0 1 .434-.213.542.542 0 0 1 .339.118.546.546 0 0 1 .207.366.545.545 0 0 1-.112.405 7.014 7.014 0 0 1-5.563 2.709A7.054 7.054 0 0 1 .95-6 7.055 7.055 0 0 1 8-13.047a7.033 7.033 0 0 1 3.485.923 7.076 7.076 0 0 1 2.465 2.369V-12.5a.551.551 0 0 1 .55-.55z",
    transform: "translate(2 16)",
    style: {
      fill: "currentColor"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRedo);
export default __webpack_public_path__ + "static/media/icon_redo.2769d214347915bd08f29fb45b882a0a.svg";
export { ForwardRef as ReactComponent };